let localeContainer = {};

const _template = require('lodash.template'); // eslint-disable-line no-underscore-dangle

let islocaleContainerInitialized = false;

const Locale = {

  /**
   @returns {Locale} */
  init() {
    return this;
  },

  /**
   * Get localised string
   * @param {string} key
   * @returns {string}
   */
  getString(key) {
    if (!islocaleContainerInitialized) {
      initLocaleContainer();
      islocaleContainerInitialized = true;
    }

    return (localeContainer[key] !== undefined) ? localeContainer[key] || '' : '';
  },

  /**
   * Get localised formatted string
   * @param {string} key
   * @param {...string} values
   * @returns {string}
   */
  getFormattedString(key, values) {
    if (!islocaleContainerInitialized) {
      initLocaleContainer();
      islocaleContainerInitialized = true;
    }

    return (localeContainer[key] !== undefined)
      ? _template(localeContainer[key])(values) || '' : '';
  },

  /**
   * Format [text] as a template with [value] as template parameters
   * @param  {string} text
   * @param  {object} value
   * @return {string}
   */
  formatString(text, value) {
    return _template(text)(value);
  },

  /**
   * Set setting in desired place
   * @param {string} key
   * @param {string} templateOrText
   */
  set(key, templateOrText) {
    localeContainer[key] = templateOrText;
  }

};

function initLocaleContainer() {
  const locale = document.getElementById('app.locale');
  if (locale) {
    try {
      localeContainer = JSON.parse(locale.innerHTML);
    } catch (e) {
      console.error('App.Locale', e);
    }
  }
}

module.exports = Locale;
